"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const PREFIX = '[redux-persistence]';
exports.receivedFunctionalAction = () => `${PREFIX} ACTION IGNORED! Actions should be objects` +
    ` with a type property but received a function! Your` +
    ` function resolving middleware (e.g. redux-thunk) must be` +
    ` placed BEFORE redux-storage!`;
exports.receivedNonObjectAction = (action) => `${PREFIX} ACTION IGNORED! Actions should be objects` + ` with a type property but received: ${action}`;
exports.missingActionType = () => `${PREFIX} ACTION IGNORED! Action objects should have a type property.`;
exports.defaultErrorHandler = () => `${PREFIX} Using default error handler, specify your own using the onError option when creating the middleware`;
